import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IAgent } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { agentsColumns } from "./components/agentsColumns";
import { agentsSearchFields } from "./components/agentsSearchFields";

export const AgentList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IAgent>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="아이러빗 현장요원 계정 및 프로필"
            />

            <SearchToolbar
                fields={agentsSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={agentsColumns}
                getRowShowPath={(row) => `/agents/show/${row.id}`}
                isError={tableQueryResult.isError}
                errorMessage="현장요원 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 현장요원이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
